import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { EnvironmentService } from './services/environment.service';

@NgModule({
    declarations: [],
    bootstrap: [],
    exports: [],
    imports: [],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: (envService: EnvironmentService) => () => envService.loadEnvFromServer(),
            deps: [EnvironmentService],
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class EcmConsumerModule {}
